import axios from 'axios';

export function gqlPost(endpoint, query, options = { token: '', traceId: '' }) {
    const { token, traceId } = options;

    return new Promise((resolve) => {
        const reqHeaders = {
            authorization: 'Bearer ' + token,
            'x-trace-id': traceId,
        };
        axios.post(endpoint, { query }, { headers: reqHeaders })
            .then(resolve)
            .catch(resolve);
    });
}

export default gqlPost;
